import api from '@/services/api'

const hostinger = {
  listarDatacenters: () => api.get('/hostinger/datacenters').then(r => r.data),
  listarCronJobs:    () => api.get('/hostinger/cron-jobs').then(r => r.data),
  crearCronJob:      (data) => api.post('/hostinger/cron-jobs', data).then(r => r.data),
  eliminarCronJob:   (id)   => api.delete(`/hostinger/cron-jobs/${id}`).then(r => r.data),
}

export default hostinger
